import React, { useState } from "react";
import { Container, Row, Col, Modal, Card, CardBody, Label, Input, FormFeedback } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { withTranslation } from "react-i18next";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

import Snackbars from "../../Utils/Snackbars";
import useRequests from '../../Utils/useRequests';


const GeneralSettings = props => {
  //meta title
  document.title = "General Settings";
  const { getRequest, postRequest } = useRequests();


  const [AlertData, setAlertData] = React.useState({
		variant: '',
		message: '',
	});
	const resetAlertData = () => {
		setTimeout(() => {
			setAlertData((AlertData) => ({
				...AlertData,
				variant: '',
				message: '',
			}));
		}, 5000);
	};


  const [StandardModal1, setStandardModal1] = React.useState(false);
  const togStandardModal1 = async (elementData) => {
    validation1.setValues({
      ...validation1.values,
      ss_id: elementData.ss_id,
      site_name: elementData.site_name
    });
    setStandardModal1(true);
  }

  const validation1 = useFormik({
    enableReinitialize: true,

    initialValues: {
      ss_id: '',
      site_name: '',
    },
    validationSchema: Yup.object({
      site_name: Yup.string()
        .matches(
          /^[a-zA-Z_\s-]+$/,
          'Please enter a valid value!'
        )
        .required('Site Name is required'),
    }),
    onSubmit: async (values) => {
      try {
        let submit1 = document.getElementById('submit1');
        submit1.disabled = true;
        submit1.textContent = 'Processing...';

        const jsonpar = JSON.stringify({
          ss_id: values.ss_id,
          site_name: values.site_name
        });
        const res = await postRequest('update-site-general-settings', jsonpar);
        if (res && res.code === 200) {
          handleLoadGetSiteSettings();

          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'success',
            message: res.message,
          }));
        }
        else {
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'error',
            message: res.message,
          }));
        }
        resetAlertData();

        submit1.disabled = false;
        submit1.textContent = 'Update';

        setStandardModal1(false);
      } catch (error) {
        console.error("Error : ", error);
      }
    }
  });

  const [StandardModal2, setStandardModal2] = React.useState(false);
  const togStandardModal2 = async (elementData) => {
    validation2.setValues({
      ...validation2.values,
      ss_id: elementData.ss_id,
      welcome_bonus: elementData.welcome_bonus
    });
    setStandardModal2(true);
  }

  const validation2 = useFormik({
    enableReinitialize: true,

    initialValues: {
      ss_id: '',
      welcome_bonus: '',
    },
    validationSchema: Yup.object({
      welcome_bonus: Yup.string()
        .matches(
          /^[#0-9.]+$/,
          'Please enter a valid value!'
        )
        .required('Welcome Bonus is required'),
    }),
    onSubmit: async (values) => {
      try {
        let submit1 = document.getElementById('submit2');
        submit1.disabled = true;
        submit1.textContent = 'Processing...';

        const jsonpar = JSON.stringify({
          ss_id: values.ss_id,
          welcome_bonus: values.welcome_bonus
        });
        const res = await postRequest('update-site-welcome-bonus-settings', jsonpar);
        if (res && res.code === 200) {
          handleLoadGetSiteSettings();

          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'success',
            message: res.message,
          }));
        }
        else {
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'error',
            message: res.message,
          }));
        }
        resetAlertData();

        submit1.disabled = false;
        submit1.textContent = 'Update';

        setStandardModal2(false);
      } catch (error) {
        console.error("Error : ", error);
      }
    }
  });

  const [StandardModal3, setStandardModal3] = React.useState(false);
  const togStandardModal3 = async (elementData) => {
    validation3.setValues({
      ...validation3.values,
      ss_id: elementData.ss_id,
      receiver_matic_wallet_address: elementData.receiver_matic_wallet_address
    });
    setStandardModal3(true);
  }

  const validation3 = useFormik({
    enableReinitialize: true,

    initialValues: {
      ss_id: '',
      receiver_matic_wallet_address: '',
    },
    validationSchema: Yup.object({
      receiver_matic_wallet_address: Yup.string()
        .required('Receiver MATIC Wallet Address is required'),
    }),
    onSubmit: async (values) => {
      try {
        let submit1 = document.getElementById('submit3');
        submit1.disabled = true;
        submit1.textContent = 'Processing...';

        const jsonpar = JSON.stringify({
          ss_id: values.ss_id,
          receiver_matic_wallet_address: values.receiver_matic_wallet_address
        });
        const res = await postRequest('update-site-receiver-matic-wallet-address-settings', jsonpar);
        if (res && res.code === 200) {
          handleLoadGetSiteSettings();

          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'success',
            message: res.message,
          }));
        }
        else {
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'error',
            message: res.message,
          }));
        }
        resetAlertData();

        submit1.disabled = false;
        submit1.textContent = 'Update';

        setStandardModal3(false);
      } catch (error) {
        console.error("Error : ", error);
      }
    }
  });

  const [StandardModal4, setStandardModal4] = React.useState(false);
  const togStandardModal4 = async (elementData) => {
    validation4.setValues({
      ...validation4.values,
      ss_id: elementData.ss_id,
      receiver_usdt_wallet_address: elementData.receiver_usdt_wallet_address
    });
    setStandardModal4(true);
  }

  const validation4 = useFormik({
    enableReinitialize: true,

    initialValues: {
      ss_id: '',
      receiver_usdt_wallet_address: '',
    },
    validationSchema: Yup.object({
      receiver_usdt_wallet_address: Yup.string()
        .required('Receiver USDT Wallet Address is required'),
    }),
    onSubmit: async (values) => {
      try {
        let submit1 = document.getElementById('submit4');
        submit1.disabled = true;
        submit1.textContent = 'Processing...';

        const jsonpar = JSON.stringify({
          ss_id: values.ss_id,
          receiver_usdt_wallet_address: values.receiver_usdt_wallet_address
        });
        const res = await postRequest('update-site-receiver-usdt-wallet-address-settings', jsonpar);
        if (res && res.code === 200) {
          handleLoadGetSiteSettings();

          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'success',
            message: res.message,
          }));
        }
        else {
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'error',
            message: res.message,
          }));
        }
        resetAlertData();

        submit1.disabled = false;
        submit1.textContent = 'Update';

        setStandardModal4(false);
      } catch (error) {
        console.error("Error : ", error);
      }
    }
  });
  
  const [GeneralSettingsTBody, setGeneralSettingsTBody] = React.useState('');
  const handleLoadGetSiteSettings = async () => {
    const res = await getRequest('get-site-settings');
    if (res && res.code === 200) {
      let originalText = res.data;

      let tempTBody = (<>
                      <tr>
                        <td>1</td>
                        <td>Site Name</td>
                        <td>{originalText.site_name}</td>
                        <td className="text-center">
                          <div className="centerLink">
                            <span title="Edit General Settings" className="font-size-14 bg-primary edit-box" onClick={(e)=>togStandardModal1(originalText)}><i className="bx bxs-edit"></i></span>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>2</td>
                        <td>Welcome Bonus</td>
                        <td>{originalText.welcome_bonus}</td>
                        <td className="text-center">
                          <div className="centerLink">
                            <span title="Edit General Settings" className="font-size-14 bg-primary edit-box" onClick={(e)=>togStandardModal2(originalText)}><i className="bx bxs-edit"></i></span>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>3</td>
                        <td>Receiver MATIC Wallet Address</td>
                        <td>{originalText.receiver_matic_wallet_address}</td>
                        <td className="text-center">
                          <div className="centerLink">
                            <span title="Edit General Settings" className="font-size-14 bg-primary edit-box" onClick={(e)=>togStandardModal3(originalText)}><i className="bx bxs-edit"></i></span>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>4</td>
                        <td>Receiver USDT Wallet Address</td>
                        <td>{originalText.receiver_usdt_wallet_address}</td>
                        <td className="text-center">
                          <div className="centerLink">
                            <span title="Edit General Settings" className="font-size-14 bg-primary edit-box" onClick={(e)=>togStandardModal4(originalText)}><i className="bx bxs-edit"></i></span>
                          </div>
                        </td>
                      </tr>
                      </>);

      setGeneralSettingsTBody(tempTBody);
    }
    else {
      let tempTBody = (<tr>
                        <td colSpan="4" className="text-center">No records found</td>
                      </tr>);

      setGeneralSettingsTBody(tempTBody);

      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'error',
        message: res.message,
      }));
    }
    resetAlertData();
  }

  React.useEffect(() => {
    handleLoadGetSiteSettings();
  }, []);


  return (
    <React.Fragment>
			{AlertData.message !== '' ? <Snackbars variant={AlertData.variant} message={AlertData.message} /> : ''}
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={props.t("Tokenizedgreen")} breadcrumbItem={props.t("General Settings")} />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="table-rep-plugin">
                    <div className="table-responsive mb-0" >
                      <table className="table table-hover table-highlight" style={{minWidth: '500px'}}>
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Title</th>
                            <th>Value</th>
                            <th className="text-center">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {GeneralSettingsTBody}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

        </Container>
      </div>

      <Modal centered backdrop="static" isOpen={StandardModal1}>
        <div className="modal-header">
          <h5 className="modal-title mt-0">General Settings</h5>
          <button type="button" onClick={(e)=>setStandardModal1(false)} className="close" data-dismiss="modal" aria-label="Close" >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <Col md={12}>
            <div className="mb-3">
              <Label className="form-label">Site Name</Label>
              <Input name="site_name" type="text" placeholder="Enter Site Name"
                onChange={validation1.handleChange}
                onBlur={validation1.handleBlur}
                value={validation1.values.site_name || ""}
                invalid={
                  validation1.touched.site_name && validation1.errors.site_name ? true : false
                }
              />
              {validation1.touched.site_name && validation1.errors.site_name ? (
                <FormFeedback type="invalid">{validation1.errors.site_name}</FormFeedback>
              ) : null}
            </div>
          </Col>
        </div>
        <div className="modal-footer">
          <button type="button" 
            id="submit1"
            onClick={(e) => {
              e.preventDefault();
              validation1.handleSubmit();
              return false;
            }}
          className="btn btn-primary" data-dismiss="modal" aria-label="Close">Update</button>
          <button type="button" onClick={(e)=>setStandardModal1(false)} className="btn btn-light" data-dismiss="modal" aria-label="Close">Close</button>
        </div>
      </Modal>

      <Modal centered backdrop="static" isOpen={StandardModal2}>
        <div className="modal-header">
          <h5 className="modal-title mt-0">General Settings</h5>
          <button type="button" onClick={(e)=>setStandardModal2(false)} className="close" data-dismiss="modal" aria-label="Close" >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <Col md={12}>
            <div className="mb-3">
              <Label className="form-label">Welcome Bonus</Label>
              <Input name="welcome_bonus" type="text" placeholder="Enter Welcome Bonus"
                onChange={validation2.handleChange}
                onBlur={validation2.handleBlur}
                value={validation2.values.welcome_bonus || ""}
                invalid={
                  validation2.touched.welcome_bonus && validation2.errors.welcome_bonus ? true : false
                }
              />
              {validation2.touched.welcome_bonus && validation2.errors.welcome_bonus ? (
                <FormFeedback type="invalid">{validation2.errors.welcome_bonus}</FormFeedback>
              ) : null}
            </div>
          </Col>
        </div>
        <div className="modal-footer">
          <button type="button" 
            id="submit2"
            onClick={(e) => {
              e.preventDefault();
              validation2.handleSubmit();
              return false;
            }}
          className="btn btn-primary" data-dismiss="modal" aria-label="Close">Update</button>
          <button type="button" onClick={(e)=>setStandardModal2(false)} className="btn btn-light" data-dismiss="modal" aria-label="Close">Close</button>
        </div>
      </Modal>

      <Modal centered backdrop="static" isOpen={StandardModal3}>
        <div className="modal-header">
          <h5 className="modal-title mt-0">General Settings</h5>
          <button type="button" onClick={(e)=>setStandardModal3(false)} className="close" data-dismiss="modal" aria-label="Close" >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <Col md={12}>
            <div className="mb-3">
              <Label className="form-label">Receiver MATIC Wallet Address</Label>
              <Input name="receiver_matic_wallet_address" type="text" placeholder="Enter Receiver MATIC Wallet Address"
                onChange={validation3.handleChange}
                onBlur={validation3.handleBlur}
                value={validation3.values.receiver_matic_wallet_address || ""}
                invalid={
                  validation3.touched.receiver_matic_wallet_address && validation3.errors.receiver_matic_wallet_address ? true : false
                }
              />
              {validation3.touched.receiver_matic_wallet_address && validation3.errors.receiver_matic_wallet_address ? (
                <FormFeedback type="invalid">{validation3.errors.receiver_matic_wallet_address}</FormFeedback>
              ) : null}
            </div>
          </Col>
        </div>
        <div className="modal-footer">
          <button type="button" 
            id="submit3"
            onClick={(e) => {
              e.preventDefault();
              validation3.handleSubmit();
              return false;
            }}
          className="btn btn-primary" data-dismiss="modal" aria-label="Close">Update</button>
          <button type="button" onClick={(e)=>setStandardModal3(false)} className="btn btn-light" data-dismiss="modal" aria-label="Close">Close</button>
        </div>
      </Modal>

      <Modal centered backdrop="static" isOpen={StandardModal4}>
        <div className="modal-header">
          <h5 className="modal-title mt-0">General Settings</h5>
          <button type="button" onClick={(e)=>setStandardModal4(false)} className="close" data-dismiss="modal" aria-label="Close" >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <Col md={12}>
            <div className="mb-3">
              <Label className="form-label">Receiver USDT Wallet Address</Label>
              <Input name="receiver_usdt_wallet_address" type="text" placeholder="Enter Receiver USDT Wallet Address"
                onChange={validation4.handleChange}
                onBlur={validation4.handleBlur}
                value={validation4.values.receiver_usdt_wallet_address || ""}
                invalid={
                  validation4.touched.receiver_usdt_wallet_address && validation4.errors.receiver_usdt_wallet_address ? true : false
                }
              />
              {validation4.touched.receiver_usdt_wallet_address && validation4.errors.receiver_usdt_wallet_address ? (
                <FormFeedback type="invalid">{validation4.errors.receiver_usdt_wallet_address}</FormFeedback>
              ) : null}
            </div>
          </Col>
        </div>
        <div className="modal-footer">
          <button type="button" 
            id="submit4"
            onClick={(e) => {
              e.preventDefault();
              validation4.handleSubmit();
              return false;
            }}
          className="btn btn-primary" data-dismiss="modal" aria-label="Close">Update</button>
          <button type="button" onClick={(e)=>setStandardModal4(false)} className="btn btn-light" data-dismiss="modal" aria-label="Close">Close</button>
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default withTranslation()(GeneralSettings);
